/**
 * Firebase認証ユーティリティ
 * VPS APIにIDトークンを送信するためのヘルパー
 */

import firebase from '@/firebase'

/**
 * 現在ログイン中のユーザーのFirebase IDトークンを取得
 * @returns IDトークン文字列
 * @throws ユーザーが未ログインの場合
 */
export async function getIdToken(): Promise<string> {
  const user = firebase.auth().currentUser
  if (!user) {
    throw new Error('未ログイン: IDトークンを取得できません')
  }
  return await user.getIdToken()
}

/**
 * FormDataにIDトークンを追加（VPS API呼び出し用）
 * ログイン中ならidTokenフィールドを追加、未ログインなら何もしない
 */
export async function appendIdToken(formData: FormData): Promise<void> {
  try {
    const token = await getIdToken()
    formData.append('idToken', token)
  } catch {
    // 未ログイン時は追加しない（移行期間はuidフォールバック）
    console.warn('[firebaseAuth] IDトークン取得失敗 — uidフォールバック')
  }
}
